import {
  DTOComponent,
  DTOCreateSubscriptionResponse,
  DTOPriceTiersResponse,
  DTOWhatsappBillingLimitV2DynamoDbEntity,
  DTOWhatsappPredictedAudienceResponse,
  DTOWhatsappSubscriptionResponse,
  DTOWhatsappTemplate,
} from "vue-app/api/dto";
import axios from "vue-app/utils/axios";
import { fixComponents } from "vue-app/components/Whatsapp/features/WhatsappEditor/WhatsappEditor.utils.ts";

export const getPredictedAudience = async () => {
  const { data } = await axios.get<DTOWhatsappPredictedAudienceResponse>("/whatsapp/predicted-audience");
  return data;
};

export const hasFreePackageClaimed = async () => {
  const { data } = await axios.get("/whatsapp/free-package-claimed");
  return data.claimed;
};

export const getPackages = async () => {
  const { data } = await axios.get<DTOPriceTiersResponse>("/whatsapp/packages");
  return data;
};

export const getCredits = async () => {
  const { data } = await axios.get<DTOWhatsappBillingLimitV2DynamoDbEntity[]>("/whatsapp/credits");
  return data;
};

export const getSubscription = async () => {
  const { data } = await axios.get<DTOWhatsappSubscriptionResponse>("/whatsapp/subscription");
  return data;
};

export const deleteSubscription = async () => {
  const { data } = await axios.delete("/whatsapp/subscription");
  return data;
};

export const postSubscription = async (packageSize: number, promotionCode?: string | null) => {
  const params = new URLSearchParams();
  params.append("package_size", packageSize.toString());
  if (promotionCode) {
    params.append("promotion_code", promotionCode);
  }
  const query = `/whatsapp/subscription?${params.toString()}`;

  const { data } = await axios.post<DTOCreateSubscriptionResponse>(query);
  return data;
};

export async function getWhatsappTemplate(templateId: number) {
  const { data } = await axios.get<DTOWhatsappTemplate>(`/whatsapp-vonage/templates/v2/${templateId}`);
  return data;
}

export async function saveWhatsappTemplate(
  id: number,
  name: string,
  components: DTOComponent[]
): Promise<DTOWhatsappTemplate> {
  const { data } = await axios.post<DTOWhatsappTemplate>(`/whatsapp-vonage/templates/v2/${id}`, {
    name,
    components: JSON.stringify(fixComponents(components)),
  });
  return data;
}

export async function publishWhatsappTemplate(id: number): Promise<DTOWhatsappTemplate> {
  const { data } = await axios.post<DTOWhatsappTemplate>(`/whatsapp-vonage/templates/v2/${id}/publish`);
  return data;
}

export async function discardWhatsappTemplate(id: number): Promise<DTOWhatsappTemplate> {
  const { data } = await axios.post<DTOWhatsappTemplate>(`/whatsapp-vonage/templates/v2/${id}/discard`);
  return data;
}

export async function sendWhatsappTemplateTest(id: number, phone: string): Promise<void> {
  await axios.post(`/whatsapp-vonage/templates/v2/${id}/send`, { phone });
}
